var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6987 8.41745C12.0295 10.6583 9.99227 12.2815 7.5909 12.2495C4.8014 12.2132 2.49724 9.90194 2.39158 7.02879C2.30423 4.65143 3.70039 2.5971 5.70305 1.77174C5.9658 1.66357 6.20108 1.98225 6.03272 2.21672C5.48891 2.9753 5.17685 3.92116 5.20503 4.94324C5.26843 7.24438 7.08583 9.12013 9.31884 9.1891C10.4403 9.22394 11.4666 8.81017 12.2436 8.10967C12.4563 7.91803 12.7818 8.13943 12.6987 8.41745Z",
    stroke: "#131926",
    strokeWidth: 0.86195
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer3);
export default __webpack_public_path__ + "static/media/Layer_3.023f53bc6a275c8790d9141750c5cd0f.svg";
export { ForwardRef as ReactComponent };